import { Route, Routes } from "react-router-dom";
import { NAVIGATION } from "../lib/navigation";
import LoginPage from "../pages/auth/LoginPage";
import DashboardPage from "../pages/inner/DashboardPage";
import { BannerPage } from "../pages/inner/master/BannerPage";
import { TeamMemberPage } from "../pages/inner/master/TeamMembers/TeamMemberPage";
import BlogTypePage from "../pages/inner/blogs/BlogTypePage";
import BlogsPage from "../pages/inner/blogs/BlogsPage";
import SkillTypePage from "../pages/inner/master/SkillTypePage";
import IndustriesPage from "../pages/inner/master/IndustriesPage";
import UploadJobPage from "../pages/inner/jobs/UploadJobPage";
import ChangePasswordPage from "../pages/inner/setting/ChangePasswordPage";
import AuthSecuredComponent from "../components/HOC/AuthSecuredComponent";
import ConfigurationPage from "../pages/inner/setting/ConfigurationPage";
import { PartnerPage } from "../pages/inner/master/PartnerPage";
import { UserListPage } from "../pages/inner/users/UserListPage";
import SkillsPage from "../pages/inner/master/SkillsPage";
import { JobsPage } from "../pages/inner/jobs/JobsPage";
import { FontsPage } from "../pages/inner/setting/FontsPage"
import AddBlogPage from "../pages/inner/blogs/AddBlogPage";
import EditBlogPage from "../pages/inner/blogs/EditBlogPage";
import { EnquiryPage } from "../pages/inner/EnquiryPage";
import { EventsPage } from "../pages/inner/EventsPage";
import { TransactionPage } from "../pages/inner/TransactionPage";
import { CvPage } from "../pages/inner/users/CvPage";
import { CoverLetterPage } from "../pages/inner/users/CoverLetterPage";
import JobsDetailPage from "../pages/inner/jobs/JobsDetailPage";
import LogoutPage from "../pages/auth/LogoutPage";
import { PendingJobs } from "../pages/inner/jobs/PendingJobs";
import EditTeamMemberPage from "../pages/inner/master/TeamMembers/EditTeamMemberPage";
import AddTeamMemberPage from "../pages/inner/master/TeamMembers/AddTeamMemberPage";
import { MemberPage } from "../pages/inner/members/MemberPage";
import AddMemberPage from "../pages/inner/members/AddMemberPage";
import EditMemberPage from "../pages/inner/members/EditMemberPage";
import { ChatsPage } from "../pages/inner/ChatsPage";

const securedComponent = (component) => {
    const LoginSecuredComponent = AuthSecuredComponent(component);
    return <LoginSecuredComponent />
}

const MainRoutes = () => {
    return (
        <Routes>

            {/* unsecured pages */}
            <Route path={NAVIGATION.AUTH_NAVIGATION.LOGIN} element={<LoginPage />} />
            <Route path={NAVIGATION.AUTH_NAVIGATION.LOGOUT} element={<LogoutPage />} />

            {/* inner pages with auth security */}
            <Route path={NAVIGATION.INNER_NAVIGATION.DASHBOARD} element={securedComponent(DashboardPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.BANNER} element={securedComponent(BannerPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.PARTNERS} element={securedComponent(PartnerPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.TEAM_MEMBERS} element={securedComponent(TeamMemberPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.ADD_TEAM_MEMBERS} element={securedComponent(AddTeamMemberPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.UPDATE_TEAM_MEMBERS} element={securedComponent(EditTeamMemberPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.SKILL_TYPE} element={securedComponent(SkillTypePage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.SKILLS} element={securedComponent(SkillsPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MASTERS.INDUSTRIES} element={securedComponent(IndustriesPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.ENQUIRIES} element={securedComponent(EnquiryPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.EVENTS} element={securedComponent(EventsPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.CHATS} element={securedComponent(ChatsPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.TRANSACTION} element={securedComponent(TransactionPage)} />

            {/* Blog */}
            <Route path={NAVIGATION.INNER_NAVIGATION.BLOGS.BLOG_TYPES} element={securedComponent(BlogTypePage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.BLOGS.BLOGS} element={securedComponent(BlogsPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.BLOGS.ADD_BLOG} element={securedComponent(AddBlogPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.BLOGS.UPDATE_BLOG} element={securedComponent(EditBlogPage)} />

            {/* Users */}
            <Route path={NAVIGATION.INNER_NAVIGATION.USERS.CVS} element={securedComponent(CvPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.USERS.COVER_LETTER} element={securedComponent(CoverLetterPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.USERS.USER_LIST} element={securedComponent(UserListPage)} />

            {/* Member */}
            <Route path={NAVIGATION.INNER_NAVIGATION.MEMBER.MEMBERS} element={securedComponent(MemberPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MEMBER.ADD_MEMBER} element={securedComponent(AddMemberPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.MEMBER.UPDATE_MEMBER} element={securedComponent(EditMemberPage)} />

            {/* Jobs */}
            <Route path={NAVIGATION.INNER_NAVIGATION.JOBS.JOBS} element={securedComponent(JobsPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.JOBS.PENDING_JOBS} element={securedComponent(PendingJobs)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.JOBS.UPLOAD_JOBS} element={securedComponent(UploadJobPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.JOBS.JOBS_DETAIL} element={securedComponent(JobsDetailPage)} />

            {/* Setting */}
            <Route path={NAVIGATION.INNER_NAVIGATION.SETTING.FONTS} element={securedComponent(FontsPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.SETTING.CHANGE_PASSWORD} element={securedComponent(ChangePasswordPage)} />
            <Route path={NAVIGATION.INNER_NAVIGATION.SETTING.CONFIGURATION} element={securedComponent(ConfigurationPage)} />

        </Routes>
    )
}

export default MainRoutes